module.exports = __webpack_public_path__ + "img/pyramid.8ed036e8.jpg";